import { encode } from '..';
export var expand = function expand(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    context = _ref.context;
  // Title of expand appears as a bold text, followed by empty line
  var result = ["*".concat(node.attrs.title, "*"), ''];
  node.forEach(function (n) {
    result.push(encode(n, context));
  });
  return result.join('\n');
};